import { createStore } from 'effector';

export const $chatPublicHexagons = createStore({});
$chatPublicHexagons.watch((state) => console.log('$chatPublicHexagons', state));

export const $isChatPublicFilters = createStore(false)
